const FinancialStatementsTypes = {
  Comparative: 1,
  Monthly: 2,
  Quarterly: 3,
  Annual: 4,
};

export { FinancialStatementsTypes };
